import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useFetch from "../Hooks/useFetch";
import { coachesURL } from "../Hooks/URL";
import { userContext } from "../Contexts/userContext";
import Coaches from "../Templates/Home/Coaches/Coaches";

function CoachesPage() {
  const { contextData, setContextData } = useContext(userContext);
  const navigate = useNavigate();

  const [page, setPage] = useState(0);
  const [pageCount, setPageCount] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [searchData, setSearchData] = useState("");
  const [search, setSearch] = useState("");
  const [Open, setOpen] = useState(false);
  const [showFilters, setShowFilters] = useState(true);

  const [filters, setFilters] = useState({
    accountPaid: "",
    // competitionType: "",
  });

  const getFilterQueryString = (filters) => {
    const queryParams = Object.entries(filters)
      .filter(([_, value]) => value !== "")
      .map(([key, value]) => {
        return `${key}=${value}`;
      })
      .filter((param) => param !== "")
      .join("&");
    return queryParams;
  };

  const [coaches, setCoaches] = useState([]);
  const [coachesNumber, setCoachesNumber] = useState(0);
  const { data, loading, error } = useFetch(
    coachesURL,
    page,
    rowsPerPage,
    search,
    null,
    false,
    `${
      getFilterQueryString(filters) ? `&${getFilterQueryString(filters)}` : ""
    }`
  );

  useEffect(() => {
    if (!loading && !error && data) {
      setCoaches(data.data?.data?.rows);
      setCoachesNumber(data.data?.data?.totalCount);
      setPageCount(data.data?.data?.numberOfPages);
    }
  }, [data, loading, error]);

  useEffect(() => {
    setContextData({ ...contextData, page: "coaches", data: "" });
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage - 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleFilterChange = (event) => {
    if (event.target.name === "categoryId") {
      setFilters({
        ...filters,
        [event.target.name]: event.target.value,
        ageGroupId: "",
      });
    } else {
      setFilters({
        ...filters,
        [event.target.name]: event.target.value,
      });
    }
  };

  return (
    <Coaches
      page={page}
      rowsPerPage={rowsPerPage}
      handleChangeRowsPerPage={handleChangeRowsPerPage}
      searchData={searchData}
      search={search}
      setSearchData={setSearchData}
      setSearch={setSearch}
      coaches={coaches}
      navigate={navigate}
      handleChangePage={handleChangePage}
      Open={Open}
      setOpen={setOpen}
      loading={loading}
      data={data}
      error={error}
      pageCount={pageCount}
      setCoaches={setCoaches}
      coachesNumber={coachesNumber}
      setPage={setPage}
      filters={filters}
      handleFilterChange={handleFilterChange}
      getFilterQueryString={getFilterQueryString}
      showFilters={showFilters}
      setShowFilters={setShowFilters}
    />
  );
}

export default CoachesPage;
